import { useFormik } from 'formik'
import { useSelector } from 'react-redux'
import { Input } from '../../../components'

import {
  Label,
  Modal,
  Percentage,
  ModalTitle,
  ModalHeader,
  FormWrapper,
  ModalContent,
  ModalTOJName,
  FormContainer,
  ProgressItem,
  ItemWrapper,
  CloseButton
} from './dashboard-jetty.styled'
import { Close } from '@material-ui/icons'
import { ConvertLocalTimeGet } from '../../../utils'
import { Colors } from '../../../styles'
import { useEffect, useState } from 'react'
import { DashboardJettyAPI } from '../../../api'

const TOJModal = ({ data, handleClose, open }) => {
  const [activities, setActivities] = useState([])
  const [isLoading, setisLoading] = useState(true)
  const { Location } = useSelector((state) => state.usersProfileReducer)

  const calculateDuration = (duration) => {
    if (duration) {
      const hours = Math.floor(duration / 60)
      const minutes = duration % 60
      return `${hours} hours ${minutes} minutes`
    }
    return ''
  }
  const FormInput = useFormik({
    enableReinitialize: true,
    initialValues: {
      Service_Type: data?.Sr_Type || '',
      Planning_Berthing_Duration: calculateDuration(
        Number(data?.Plan_Berth_Dur)
      ),
      Actual_Time_Arrival:
        ConvertLocalTimeGet(
          Location.LocationDescription,
          data?.Ata,
          'DD/MM/yyyy HH:mm'
        ) || '',
      Planning_Time_Departure:
        ConvertLocalTimeGet(
          Location.LocationDescription,
          data?.Plan_Depart,
          'DD/MM/yyyy HH:mm'
        ) || ''
    }
  })

  const _getActivity = async () => {
    if (!data?.SrNo) return
    try {
      const queryParams = `skip=0&take=1000&filter=[{"type":"text","field":"sr_no","value":"${data?.SrNo}"}]&sort=id|desc`
      const res = await DashboardJettyAPI.GetActivity(queryParams)
      if (res?.data?.length) {
        const activitiesData = res.data
        setActivities(activitiesData)
        setisLoading(false)
      } else {
        setActivities([])
        setisLoading(false)
      }
    } catch (error) {
      setisLoading(false)
      console.error('Error fetching activity:', error)
    }
  }

  useEffect(() => {
    if (open) {
      _getActivity()
    }
  }, [data?.SrNo, open])

  return (
    <Modal fullWidth open={open} maxWidth='md'>
      <ModalHeader>
        <ModalTitle>{data?.Jetty_Name}</ModalTitle>
        <CloseButton onClick={handleClose}>
          <Close htmlColor={Colors.white} />
        </CloseButton>
      </ModalHeader>
      <ModalTOJName>TOJ #{data?.SrNo}</ModalTOJName>
      <ModalContent>
        <FormContainer>
          <FormWrapper>
            <Input
              form={FormInput}
              type='text'
              id='vf_manage_modal_service_type'
              label='Service Type'
              name='Service_Type'
              placeholder='Service Type'
              value={FormInput.values.Service_Type || ''}
              inputProps={{
                tabIndex: 8,
                readOnly: true
              }}
            />
          </FormWrapper>
          <FormWrapper>
            <Input
              form={FormInput}
              type='text'
              id='vf_manage_modal_planning_time_departure'
              label='Planning Time Departure'
              name='Planning_Time_Departure'
              placeholder='Planning Time Departure'
              tabIndex={6}
              inputProps={{
                tabIndex: 8,
                readOnly: true
              }}
            />
          </FormWrapper>
        </FormContainer>
        <FormContainer>
          <FormWrapper>
            <Input
              form={FormInput}
              type='text'
              id='vf_manage_modal_actual_time_arrival'
              label='Actual Time Arrival'
              name='Actual_Time_Arrival'
              placeholder='Actual Time Arrival'
              tabIndex={6}
              inputProps={{
                tabIndex: 8,
                readOnly: true
              }}
            />
          </FormWrapper>
          <FormWrapper>
            <Input
              form={FormInput}
              type='text'
              id='vf_manage_modal_planning_berthing_duration'
              label='Planning Berthing Duration'
              name='Planning_Berthing_Duration'
              placeholder='Planning Berthing Duration'
              value={FormInput.values.Planning_Berthing_Duration || ''}
              inputProps={{
                tabIndex: 8,
                readOnly: true
              }}
            />
          </FormWrapper>
        </FormContainer>
        <ItemWrapper>
          {isLoading ? (
            <div>Loading activities...</div>
          ) : (
            activities.map((activity) => (
              <ProgressItem key={activity.id}>
                <Label>{activity.Activity_Name}</Label>
                <Percentage>{activity.Progress || 0}%</Percentage>
              </ProgressItem>
            ))
          )}
        </ItemWrapper>
      </ModalContent>
    </Modal>
  )
}

export default TOJModal
